import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from '../auth/auth.module';
import { DateRangeModule } from './date-range/date-range.module';
import { FormControlRawValuePipe } from './form-control-raw-value.pipe';
import { TimeToolsModule } from './time-tools/time-tools.module';
import { ToolsModule } from './tools/tools.module';
import { CurrencySymbolPipe } from './currency-symbol.pipe';

@NgModule({
  declarations: [FormControlRawValuePipe, CurrencySymbolPipe],
  imports: [CommonModule],
  exports: [
    FormControlRawValuePipe,
    DateRangeModule,
    AuthModule,
    ToolsModule,
    TimeToolsModule,
    CurrencySymbolPipe,
  ],
})
export class SharedModule {}
